import { kebabCase, startCase } from "lodash";
import { FontMap } from "../types";
import { NextFontWithVariable } from "next/dist/compiled/@next/font";

export const onImportFonts = (fonts: FontMap): NextFontWithVariable[] => {
  return Object.keys(fonts).map((key) => {
    const kebab = kebabCase(key);
    const formattedFontName = startCase(kebab).split(" ").join("-");
    return formattedFontName as unknown as NextFontWithVariable;
  });
};
